export { RecipientPremiumEcardView as default } from './RecipientPremiumEcardView';
